import RPMContactInfo from './contact-info';
import './contact-info.css';

export default RPMContactInfo;
